/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * BFF Support
 * This is the API for the portal frontend and serves as the gateway to the backend services.
 * OpenAPI spec version: 1.2.0
 */
import { adapter } from './adapter';
export interface HotelImages {
  hotelId: string;
  /** @minItems 0 */
  images: Image[];
}

export interface Image {
  large: ImageUrl;
  small: ImageUrl;
  categoryCodes?: string[];
  tourOperatorAndSeasons?: TourOperatorAndSeasons[];
}

export interface ImageUrl {
  /** full url to the image, page or whatever */
  url: string;
}

export interface TourOperatorAndSeasons {
  /** tourOperatorCode */
  tourOperator?: string;
  seasons?: string[];
}

export interface TourOperatorDescriptionResult {
  content?: string;
  title?: string;
}

/**
 * procied smartseer profile
 */
export interface SmartseerProfileResponse {
  /** json string with full raw response from smartseer @see https://docs.smartseer.com/users/v3?trackingId=i15580#/paths/~1users~1v3~1%7BuserId%7D~1profiles~1current/post */
  rawProfile?: string;
}

export interface MetaResponse {
  userCity: string;
}

/**
 * contains a list of hotel images
 */
export interface HotelImagesResponse {
  /** @minItems 0 */
  hotels: HotelImages[];
}

export type TourOperatorDescriptionResponse = TourOperatorDescriptionResult[];

/**
 * contains cee term ID
 */
export interface OfferShortcutResponse {
  termID: string;
}

/**
 * a generic bad request error
 */
export interface BadRequestResponse {
  message: string;
}

/**
 * contains some detailed error information.
 */
export interface ErrorDetail {
  /** the error code. */
  code: number;
  /** the error message. use only for internal evaluation. */
  message: string;
  /**
   * describes a field or parameter this error belongs to. may be null.
   * @nullable
   */
  relate: string | null;
}

/**
 * the container to return error information.
 */
export interface ErrorResponse {
  /** the error code. */
  code: number;
  /** the error message. use only for internal evaluation. */
  message: string;
  'error-details': ErrorDetail[];
}

/**
 * An error response
 */
export type ErrorResponseResponse = ErrorResponse;

/**
 * A bad request response
 */
export type BadRequestResponseResponse = BadRequestResponse;

/**
 * defines the last day of vacation; not always the day of arrival in travellers home.
 */
export type DateMaxParameter = string;

/**
 * defines the first day of vacation.
 */
export type DateMinParameter = string;

/**
 * identificator for hotel, id with suffix to identify source of id
 */
export type HotelParameter = string;

export type TravelTypeParameter = typeof TravelTypeParameter[keyof typeof TravelTypeParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TravelTypeParameter = {
  packageTour: 'packageTour',
  ownArrival: 'ownArrival',
} as const;

/**
 * uuid, identifying the user without knowing his name
 */
export type XUserIdParameter = string;

export type GetHotelImagesParams = {
/**
 * identificators for multiple hotels, ids with suffix to identify source of id
 */
hotels: string[];
};

export type GetOfferShortcutParams = {
/**
 * offerID of cee offer
 */
offerID: string;
};

export type GetSmartseerProfileParams = {
/**
 * userID getting from BD4Travel Cookie
 */
BD4ID: string;
};

export type GetTourOperatorDescriptionParams = {
/**
 * identificator for hotel, id with suffix to identify source of id
 */
hotel: HotelParameter;
tourOperator: string;
/**
 * defines the first day of vacation.
 */
dateMin: DateMinParameter;
/**
 * defines the last day of vacation; not always the day of arrival in travellers home.
 */
dateMax: DateMaxParameter;
/**
 * defines the travel type.
 */
travelType?: TravelTypeParameter;
/**
 * service code from supplier/organizer. is like a hotelCode e.g. 'PMI8774'
 */
serviceCode?: string | null;
};

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

/**
 * @summary retrieve image urls from reSource image api
 */
export type getHotelImagesResponse200 = {
  data: HotelImagesResponse
  status: 200
}

export type getHotelImagesResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getHotelImagesResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400>
}
    
export type getHotelImagesResponseComposite = getHotelImagesResponse200 | getHotelImagesResponse400 | getHotelImagesResponseDefault;
    
export type getHotelImagesResponse = getHotelImagesResponseComposite & {
  headers: Headers;
}

export const getGetHotelImagesUrl = (params: GetHotelImagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/images?${stringifiedParams}` : `/images`
}

export const getHotelImages = async (params: GetHotelImagesParams, options?: RequestInit): Promise<getHotelImagesResponse> => {
  
  return adapter<getHotelImagesResponse>(getGetHotelImagesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary get service independent information
 */
export type getMetaResponse200 = {
  data: MetaResponse
  status: 200
}

export type getMetaResponse204 = {
  data: void
  status: 204
}
    
export type getMetaResponseComposite = getMetaResponse200 | getMetaResponse204;
    
export type getMetaResponse = getMetaResponseComposite & {
  headers: Headers;
}

export const getGetMetaUrl = () => {


  

  return `/meta`
}

export const getMeta = async ( options?: RequestInit): Promise<getMetaResponse> => {
  
  return adapter<getMetaResponse>(getGetMetaUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary get term information for cee
 */
export type getOfferShortcutResponse200 = {
  data: OfferShortcutResponse
  status: 200
}
    
export type getOfferShortcutResponseComposite = getOfferShortcutResponse200;
    
export type getOfferShortcutResponse = getOfferShortcutResponseComposite & {
  headers: Headers;
}

export const getGetOfferShortcutUrl = (params: GetOfferShortcutParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer-shortcut?${stringifiedParams}` : `/offer-shortcut`
}

export const getOfferShortcut = async (params: GetOfferShortcutParams, options?: RequestInit): Promise<getOfferShortcutResponse> => {
  
  return adapter<getOfferShortcutResponse>(getGetOfferShortcutUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary get current profile for tracked customer
 */
export type getSmartseerProfileResponse200 = {
  data: SmartseerProfileResponse
  status: 200
}

export type getSmartseerProfileResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getSmartseerProfileResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400>
}
    
export type getSmartseerProfileResponseComposite = getSmartseerProfileResponse200 | getSmartseerProfileResponse400 | getSmartseerProfileResponseDefault;
    
export type getSmartseerProfileResponse = getSmartseerProfileResponseComposite & {
  headers: Headers;
}

export const getGetSmartseerProfileUrl = (params: GetSmartseerProfileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/profile?${stringifiedParams}` : `/profile`
}

export const getSmartseerProfile = async (params: GetSmartseerProfileParams, options?: RequestInit): Promise<getSmartseerProfileResponse> => {
  
  return adapter<getSmartseerProfileResponse>(getGetSmartseerProfileUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary get tour operator description for a hotel
 */
export type getTourOperatorDescriptionResponse200 = {
  data: TourOperatorDescriptionResponse
  status: 200
}

export type getTourOperatorDescriptionResponse204 = {
  data: void
  status: 204
}

export type getTourOperatorDescriptionResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getTourOperatorDescriptionResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 204 | 400>
}
    
export type getTourOperatorDescriptionResponseComposite = getTourOperatorDescriptionResponse200 | getTourOperatorDescriptionResponse204 | getTourOperatorDescriptionResponse400 | getTourOperatorDescriptionResponseDefault;
    
export type getTourOperatorDescriptionResponse = getTourOperatorDescriptionResponseComposite & {
  headers: Headers;
}

export const getGetTourOperatorDescriptionUrl = (params: GetTourOperatorDescriptionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tour-operator-description?${stringifiedParams}` : `/tour-operator-description`
}

export const getTourOperatorDescription = async (params: GetTourOperatorDescriptionParams, options?: RequestInit): Promise<getTourOperatorDescriptionResponse> => {
  
  return adapter<getTourOperatorDescriptionResponse>(getGetTourOperatorDescriptionUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
